import { Component, Vue } from 'vue-property-decorator';
import PageText from '@/components/page/text/Text.vue';

@Component({
  components: { PageText },
  metaInfo() {
    const { description, keywords, title } = this as PageSmartInfo;
    return { description, keywords, title };
  },
})
export default class PageSmartInfo extends Vue {
  // Readonly
  content: string = '';
  description: string = '';
  keywords: string = '';
  title: string = 'Независимая оценка качества программ дополнительного образования детей';
}



// WEBPACK FOOTER //
// ./src/pages/noko/info/script.ts